module.exports = __webpack_public_path__ + "media/images/vision/dark_bg-8a3ebc3ab2a399111c040f784e8c3d29.jpg";